import { BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react';

import { ApiError } from 'lib/errors';
import ApiCanceledError from 'lib/errors/ApiCanceledError';
import ApiNetworkError from 'lib/errors/ApiNetworkError';
import ApiNonRetryableResponseError from 'lib/errors/ApiNonRetryableResponseError';
import ApiRequestError from 'lib/errors/ApiRequestError';
import ApiResponseError from 'lib/errors/ApiResponseError';
import { ApiModel } from 'lib/interfaces/api';

export const LIST_TAG_ID = 'LIST';

const customBaseQuery: BaseQueryFn<any, unknown, Error | ApiError> = async (args) => {
  try {
    const result = await args;
    return { data: result };
  } catch (err) {
    // Only gracefully handle API errors
    if (err instanceof ApiCanceledError) {
      return { data: null };
    }
    if (
      err instanceof ApiNetworkError ||
      err instanceof ApiResponseError ||
      err instanceof ApiRequestError ||
      err instanceof ApiNonRetryableResponseError
    ) {
      return { error: err };
    }

    throw err;
  }
};

// Define a service using a base URL and expected endpoints
export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  tagTypes: [
    ApiModel.CaseVariableDefinition,
    ApiModel.ExternalIntegration,
    ApiModel.ExternalIntegrationConfig,
    ApiModel.ExternalIntegrationLog,
    ApiModel.ExternalIntegrationVendor,
    ApiModel.PlatformNode,
    ApiModel.SAR,
    ApiModel.Transaction,
    ApiModel.TransactionType,
    ApiModel.User,
    ApiModel.WorkflowBlock,
    ApiModel.WorkflowModule,
    ApiModel.WorkflowRunStep,
  ],
  baseQuery: customBaseQuery,
  endpoints: () => ({}),
});
